import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17640 12238"
    {...props}
  >
    <path
      d="M228 6119 9210 105 5228 5437h12285v1363H5228l3982 5332z"
      style={{
        fill: "#2b2a29",
        stroke: "#1c1b17",
        strokeWidth: 254.186,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
